export const BRAND = {
  name: 'Vegan Danish Bakery Foods',
  short: 'VDBF',
  tagline: 'Premium Plant-Based Breakfast Options',
  promise: 'Chef Inspired · Student Approved',
  logo: 'https://customer-assets.emergentagent.com/job_9bb1f5b4-dff8-415d-a89c-b801fc948062/artifacts/fvq8xfbx_VDBF-Logo.png',
  email: 'toronto@vegandanishbakery.com',
  phone: '647-352-1312',
  address: '1312 Queen Street West · Toronto, ON M6K 1L8',
  website: 'vegandanishbakeryfoods.com'
};
